import { createAction } from 'redux-act'

import { MenuItem } from './types'

const setBadge = createAction<any>('Set badge')

const setUserMenuBadge = createAction<MenuItem[]>('Set user menu badge')

const setDisablement = createAction('Set disablement', (key, isDisabled) => ({
  key,
  isDisabled,
}))

const setVisibility = createAction('Set visibility', (key, isVisible) => ({
  key,
  isVisible,
}))

const updateUserMenuState = createAction<MenuItem[]>('Update user menu state')

const fetchReviewItemsNumberStart = createAction('Fetch review items number start')

const fetchReviewItemsNumberSuccess = createAction<any>('Fetch review items number success')

const fetchReviewItemsNumberFail = createAction<any>('Fetch review items number fail')

const addDigitalStylistQuiz = createAction('Add digital stylist quiz')

const addInviteFriendMenuItem = createAction('Add the invite friend menu item')

const fetchUserMenuStart = createAction('Fetch user menu start')

const fetchUserMenuSuccess = createAction<MenuItem[]>('Fetch user menu success')

const fetchUserMenuFail = createAction('Fetch user menu fail')

export default {
  setBadge,
  setUserMenuBadge,
  setDisablement,

  setVisibility,
  updateUserMenuState,

  fetchReviewItemsNumberStart,
  fetchReviewItemsNumberSuccess,
  fetchReviewItemsNumberFail,

  addDigitalStylistQuiz,
  addInviteFriendMenuItem,

  fetchUserMenuStart,
  fetchUserMenuSuccess,
  fetchUserMenuFail,
}
